module.exports = __webpack_public_path__ + "img/logo-kbo.cfc85697.jpg";